import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IPwcImportPanelButtonHOCProps } from './types';
import { IWebhooksPanelButtonEvents, IWebhooksPanelButtonFields } from '../../components/WebhooksPanelButton/types';
import { WebhooksPanelButton } from '../../components/WebhooksPanelButton/WebhooksPanelButton';
import { onClick } from './events/onClick';
import { isKanbanchiUser } from '../../../../../../../../store/model/authUser/selectors/isKanbanchiUser';

const mapStateToProps = (
    state: IApplicationState
): IWebhooksPanelButtonFields => {
    return {
        isShow: isKanbanchiUser(state),
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { onClick: ownOnClick }: IPwcImportPanelButtonHOCProps
): IWebhooksPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const WebhooksPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(WebhooksPanelButton);
